import "./App.css";
import SignIn from "./SignIn";
import { useEffect, useState } from "react";
import BottomTabs from "./BottomTabs";
import Home from "./Home";
import Teams from "./Teams";
import Games from "./Games";
import WheelGame from "./Wheel";
import WheelOuter from "./Wheelouter";
import Profile from "./Profile";
import Calculator from "./Calculator";
import SignUp from "./SignUp";
import RefCode from "./RefCode";
import { postEvent } from "@telegram-apps/sdk";
import Landing from "./Landing";
import BmrCalculator from "./BmrCalculator";
import HomeTG from "./HomeTG";
import BottomTabsTG from "./BottomTabsTG";
import TeamsTG from "./TeamsTG";
import ProfileTG from "./ProfileTG";
import EmoryanAdventure from "./EmoryanAdventure";


import {
  getFirestore,
  collection,
  query,
  where,
  getDocsFromServer,
  addDoc,
  getDocs,
  deleteDoc,
} from "firebase/firestore";
import { onAuthStateChanged ,signOut} from "firebase/auth";
import { auth } from "./firebaseConfig";
import { MVXStats } from "./MvxStats";
export default function Main() {
  const [localAllowed, setLocalAllowed] = useState(false);
  const [loadText, setLoadText] = useState("Loading..");
  const [tgAllowed, setTgAllowed] = useState(false);
  const [signUpMode, setSignUpMode] = useState(false);
  const [refCodeMode, setRefCodeMode] = useState(false);
  const [hash, setHash] = useState("");
  const [openSignIn, setOpenSignIn] = useState(false);
  const [isTgUser, setIsTgUser] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);

  global.isLocalUser = () => {
    return isTgUser;
  }

  const profileData = {
    userData: {
      uuid: "",
      email: "",
      emailVerified: false,
      displayName: "",
      photoUrl: "",
      createdAt: "",
      heightUnit: "",
      claimHistory: null,
      weight: null,
      height: null,
      firstName: "",
      lastName: "",
      imageUrl: "",
      weightUnit: "",
      claimedAt: null,
      dateOfBirth: "",
      gender: "",
      id: "",
      verifiedPhoneNumber: false,
      formatPref: "",
      phoneNumber: "",
      unitPref: "",
      age: null,
      walletAddress: null,
      historySynced: null,
      refCode: "",
    },
    lastSync: null,
    registrationDate: "",
    totalCalories: 0,
    totalEMRS: 0,
    referral_code: "",
    total_team_members: 0,
    nftLevel: 0,
    parentAccount: {
      first_name: "",
      last_name: "",
      email: "",
      image_url: "",
    },
    calorie_emrs_value: {
      activity_calorie: 0,
      bmr_calorie: 0,
    },
  };
  const claimData = {
    daily_total_calories: 0,
    claimed_calories_today: 0,
    claimable_calories: 0,
    claimable_calories_seconds: 0,
    last_bmr_claim: "",
    claim_details: {
      previous_day: 0,
      current_day: 0,
    },
    emrs: 0,
  };
  const teamData = {
    user_id: 0,
    first_name: "",
    last_name: "",
    image_url: "",
    referral_code: "",
    refCode: "",
    claimable_emrs: 0,
    total_team_members: 0,
    teams: {
      level: 0,
      gain_percentage: 0,
      members: [],
    },
  };
  global.openUrl = (url) => {
    if (window.Telegram.WebApp) {
      window.Telegram.WebApp.openLink(url);
    } else {
      window.open(url, "_blank");
    }
  };
  global.downloadApplication = () => {
    if (window.Telegram.WebApp) {
      window.Telegram.WebApp.openLink("https://emorya.com/#/landing");
    } else {
      window.open("https://emorya.com/#/landing", "_blank");
    }
  };
  global.goToSignIn = (status = true) => {
    setOpenSignIn(status);
  };
  global.logoutNow = () => {
    console.log("logout Called");
    localStorage.setItem("SIGNEDIN", "0");
    localStorage.removeItem("USERDATA");
    removeUserSession();
    handleLogout();
  };


  function handleLogout() {
    signOut(auth)
      .then(() => {
        console.log("User signed out.");
        // Optionally redirect or update UI
      })
      .catch((error) => {
        console.error("Error signing out:", error);
      });
  }


  const removeUserSession = async () => {
    const tg = window.Telegram.WebApp;
    const user = tg.initDataUnsafe?.user;
    if (!user || !user.id) {
      checkSignedIn();
      return false;
    }
    const tgUserid = user.id;
    try {
      const q = query(
        collection(db, "telegram_sessions"),
        where("tgUserid", "==", parseInt(tgUserid))
      );
      const querySnapshot = await getDocs(q);
      for (const docSnapshot of querySnapshot.docs) {
        await deleteDoc(docSnapshot.ref);
      }
      checkSignedIn();
    } catch (error) {
      checkSignedIn();
      //      console.error("Error removing session:", error);
    }
  };
  const baseUrl = "https://api.emorya.com";
  //  const baseUrl = "http://localhost:8888/telegram/nutgram/backend/";
  const [username, setUsername] = useState("User");
  const [signedIn, setSignedIn] = useState(false);
  const [section, setSection] = useState("HOMETG");
  const [profileCreated, setProfileCreated] = useState(true);
  const checkSignedIn = async () => {


    /*
    const userFB = auth.currentUser;
    console.log('Check signed in called');
    if (userFB) {
      console.log('User found');
      const token = await userFB.getIdToken(true);
      console.log("Token refreshed on focus:", token);
      
      var data = {
        token: token,
        email: userFB.email,
        name: userFB.displayName,
        refreshToken: userFB.refreshToken,
        localId: userFB.reloadUserInfo.localId,
        photoURL: userFB.photoURL,
        phoneNumber: userFB.phoneNumber,
      };
      data = JSON.stringify(data);
      localStorage.setItem("USERDATA", data);
    }else{
      console.log('User not found');
    }
      */


    if (
      localStorage.getItem("SIGNEDIN") &&
      localStorage.getItem("SIGNEDIN") === "1"
    ) {
      setSignedIn(true);
    } else {
      const tg = window.Telegram.WebApp;
      var user = tg.initDataUnsafe?.user;
      if ((!user || !user.id) && localAllowed) {
        user = {
          first_name: "Vijit",
          last_name: "Singhai",
          id: 6000000,
          //id: 64288466,
          username: "justvijit",
          photo_url:
            "https://t.me/i/userpic/320/xoTIlGHhF_fxKB8znaEKXXh-XrK3z4kqxDpdt1O0jQwnmqpY1yLosyZQsVIP7cls.svg",
        };
      }
      // ||;
      if (!user || !user.id) {
        setLoadText(
          "Unable to serve at the moment. Please reload or try again later."
        );
        return false;
      }
      const tgUserid = user.id;
      const userdata = await getUserTgToken(tgUserid);
      if (userdata) {
        localStorage.setItem("SIGNEDIN", "1");
        localStorage.setItem("USERDATA", userdata);
        setSignedIn(true);
      } else {
        setSignedIn(false);
        checkRegisteredTgUser();
      }
    }
  };
  global.getTeamData = () => {
    return teamData;
  };
  global.getProfileData = () => {
    return profileData;
  };
  global.getClaimData = () => {
    return claimData;
  };
  global.getBaseUrl = () => {
    return baseUrl;
  };
  global.signInNow = () => {
    setSection("HOME");
    setRefCodeMode(false);
    localStorage.setItem("SIGNEDIN", 1);
    setSignedIn(true);
  };
 
  useEffect(() => {
    checkSignedIn();
  }, []);
  global.disableOtherPages = () => {
    setProfileCreated(false);
  };
  global.enableOtherPages = () => {
    setSection("HOME");
    setProfileCreated(true);
  };
  global.changeSection = (section) => {
    setSection(section);
  };
  const getUserTgToken = async (tgUserid) => {
    tgUserid = parseInt(tgUserid);
    try {
      const q = query(
        collection(db, "telegram_sessions"),
        where("tgUserid", "==", tgUserid) // Querying by field, not doc ID
      );
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        return querySnapshot.docs[0].data().userdata; // Return token from first matching record
      } else {
        return null; // No matching document found
      }
    } catch (error) {
      console.error("Error retrieving token:", error);
      return null;
    }
  };
  const getSection = (currentSection = null) => {
    if (currentSection === null) currentSection = section;
    if (hash != "#WHEEL") window.location.hash = "";
    switch (currentSection) {
      case "HOME": {
        return <Home></Home>;
      }
      case "TEAMS": {
        return <Teams></Teams>;
      }
      case "WHEEL": {
        return <WheelGame></WheelGame>;
      }
      case "WHEELOUTER": {
        return <WheelOuter></WheelOuter>;
      }
      case "BMRCALCULATOR": {
        return <BmrCalculator></BmrCalculator>;
      }
      case "GAMES": {
        return <Games></Games>;
      }
      case "PROFILE": {
        return <Profile></Profile>;
      }
      case "CALCULATOR": {
        return <Calculator></Calculator>;
      }
      case "REFCODE": {
        return <RefCode></RefCode>;
      }
      case "HOMETG": {
        return <HomeTG></HomeTG>;
      }
      case "TEAMSTG": {
        return <TeamsTG></TeamsTG>;
      }
      case "PROFILETG": {
        return <ProfileTG></ProfileTG>;
      }
      case "MVXSTATS": {
        return <MVXStats></MVXStats>;
      }
      case "EMORYANADVENTURE": {
        return <EmoryanAdventure></EmoryanAdventure>;
      }
      default:
        break;
    }
  };
  global.updateSignUpMode = (mode) => {
    setSignUpMode(mode);
  };
  global.updateRefCodeMode = (mode) => {
    setRefCodeMode(mode);
  };
  const [isGauth, setIsGauth] = useState(false);
  global.openTGHome = () => {
    setIsTgUser(true);
    setIsNewUser(false);
    global.changeSection("HOMETG");
  };
  const db = getFirestore();
  async function checkIfTelegramUserExists(tgUserid) {
    tgUserid = parseInt(tgUserid);
    try {
      const q = query(
        collection(db, "telegram_users"),
        where("tgUserid", "==", Number(tgUserid))
      );
      const querySnapshot = await getDocsFromServer(q);
      if (!querySnapshot.empty) {
        console.log(`User with tgUserid ${tgUserid} exists.`);
        return true; // User exists
      } else {
        console.log(`User with tgUserid ${tgUserid} does not exist.`);
        return false; // User does not exist
      }
    } catch (error) {
      console.error("Error checking user existence:", error);
      return null;
    }
  }
  const getTotalCalories = async (tgUserid) => {
    try {
      // Query Firestore for the document with the matching tgUserid
      const usersRef = collection(db, "telegram_users");
      const q = query(usersRef, where("tgUserid", "==", tgUserid));
      const querySnapshot = await getDocsFromServer(q);
      if (!querySnapshot.empty) {
        // Assuming tgUserid is unique, retrieve the first matching document
        const userData = querySnapshot.docs[0].data();
        console.log("Total Calories:", userData.totalCalories);
        if (userData.totalCalories == 0) {
          global.changeSection("BMRCALCULATOR");
        } else {
          setIsTgUser(true);
        }
        return;
        //      return userData.totalCalories;
      } else {
        console.log("No matching user found.");
        return null;
      }
    } catch (error) {
      console.error("Error fetching totalCalories:", error);
      return null;
    }
  };
  const checkRegisteredTgUser = () => {
    const tg = window.Telegram.WebApp;
    var user = tg.initDataUnsafe?.user;
    if ((!user || !user.id) && localAllowed) {
      user = {
        first_name: "Vijit",
        last_name: "Singhai",
        id: 6000000,
        username: "justvijit",
        photo_url:
          "https://t.me/i/userpic/320/xoTIlGHhF_fxKB8znaEKXXh-XrK3z4kqxDpdt1O0jQwnmqpY1yLosyZQsVIP7cls.svg",
      };
    }
    if (!user || !user.id) {
      setLoadText(
        "Unable to serve at the moment. Please reload or try again later."
      );
      return false;
    }
    const tgUserid = user.id;
    const myHeaders = new Headers();
    const raw = "";
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      "https://api.emorya.com/telegram/user-exists?telegramId=" + tgUserid,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          setTgAllowed(true);
          checkTgUser();
          throw new Error(`HTTP error! Status: ${response.status}`);
        } else {
          setTgAllowed(false);
          console.log("Logout From 12");
          global.goToSignIn();
        }
        return response.text();
      })
      .then((result) => {
        result = JSON.parse(result);
      })
      .catch((error) => {
        console.log("from catch");
        setTgAllowed(true);
        checkTgUser();
        console.error(error);
      });
  };
  const checkTgUser = () => {
    const tg = window.Telegram.WebApp;
    //  if(!tg.initDataUnsafe?.user)  return;
    var user = tg.initDataUnsafe?.user;
    if ((!user || !user.id) && localAllowed) {
      user = {
        first_name: "Vijit",
        last_name: "Singhai",
        id: 6000000,
        username: "justvijit",
        photo_url:
          "https://t.me/i/userpic/320/xoTIlGHhF_fxKB8znaEKXXh-XrK3z4kqxDpdt1O0jQwnmqpY1yLosyZQsVIP7cls.svg",
      };
    }
    const tgUserid = user.id;
    localStorage.setItem("TGUSERID", tgUserid);
    console.log("user", user);
    setUsername(user.first_name);
    if (tgUserid) {
      checkIfTelegramUserExists(tgUserid).then((exists) => {
        if (exists) {
          setIsNewUser(false);
          getTotalCalories(tgUserid);
        } else if (exists === false) {
          setIsNewUser(true);
          localStorage.setItem("TELEGRAMUSERNAME", user.first_name);
          const newUser = {
            firstName: user.first_name || "",
            lastName: user.last_name || "",
            phoneNumber: "", // Telegram does not provide phone number directly
            tgUserid: user.id, // Get Telegram User ID
            tgUsername: user.username || "",
            totalCalories: 0,
            totalEMRS: 0,
            imageUrl: user.photo_url || "",
          };
          saveTelegramUser(newUser);
        } else {
          setLoadText(
            "Unable to serve at the moment. Please reload or try again later."
          );
        }
      });
    }
  };
  async function saveTelegramUser(userData) {
    try {
      const docRef = await addDoc(collection(db, "telegram_users"), {
        firstName: userData.firstName || "",
        lastName: userData.lastName || "",
        phoneNumber: userData.phoneNumber || "",
        tgUserid: userData.tgUserid || 0, // Telegram user ID from Telegram WebApp
        tgUsername: userData.tgUsername || "",
        totalCalories: userData.totalCalories || 0,
        totalEMRS: userData.totalEMRS || 0,
        imageUrl: userData.imageUrl || "",
        gender: "",
        height: 0,
        heightUnit: "meter",
        weight: 0,
        weightUnit: "kg",
        dateOfBirth: "",
        age: 0,
      });
      console.log("User data saved with ID:", docRef.id);
      return docRef.id; // Return the auto-generated document ID
    } catch (error) {
      console.error("Error saving user data:", error);
      return null;
    }
  }
  return (
    <>
      <div className="App">
        <>
          {signedIn ? (
            <>
              {profileCreated == true ? (
                <>
                  {hash && hash == "#WHEEL" ? (
                    <>{getSection("WHEEL")}</>
                  ) : (
                    <>
                      {section == "HOMETG" ? getSection("HOME") : getSection()}
                    </>
                  )}
                  <BottomTabs section={section}></BottomTabs>
                </>
              ) : (
                <>{getSection("PROFILE")}</>
              )}
            </>
          ) : (
            <>
              {refCodeMode ? (
                <>
                  <RefCode></RefCode>
                </>
              ) : (
                <>
                  {signUpMode ? (
                    <>
                      <SignUp></SignUp>
                    </>
                  ) : (
                    <>
                      {openSignIn ? (
                        <>
                          <SignIn tgAllowed={tgAllowed}></SignIn>
                        </>
                      ) : (
                        <>
                          {section == "WHEELOUTER123" ? (
                            <>{getSection("WHEELOUTER")}</>
                          ) : (
                            <>
                              {section == "BMRCALCULATOR" ? (
                                <>{getSection("BMRCALCULATOR")}</>
                              ) : (
                                <>
                                  {isNewUser ? (
                                    <>{getSection("BMRCALCULATOR")}</>
                                  ) : (
                                    <>
                                      {isTgUser ? (
                                        <>
                                          {getSection()}
                                          <BottomTabsTG section={section}></BottomTabsTG>
                                        </>
                                      ) : (
                                        <>
                                          <div
                                            className="section"
                                            style={{
                                              justifyContent: "center",
                                            }}
                                          >
                                            <div
                                              style={{
                                                padding: 40,
                                              }}
                                            >
                                              {loadText}
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      </div>
    </>
  );
}
